/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxUploadFile } from "../../funcs/sandboxUploadFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UploadWorkspaceFileRequest$inboundSchema,
};

export const tool$sandboxUploadFile: ToolDefinition<typeof args> = {
  name: "sandbox-upload-file",
  description: `Upload Workspace File

Upload raw bytes into the session workspace at the given path.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxUploadFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
